(ns frontend.view.settings2.security.events
  (:require
   [frontend.view.settings2.security.db :as db]
   [frontend.logging :as logging]
   [frontend.actions.excel-export :as excel-export-actions]
   [frontend.actions.tenant :as tenant-actions]
   [common.util :as cu]))

(defn save-tenant!
  [tenant-id attribute value on-success! on-error!]
  (tenant-actions/*->update! tenant-id
                             attribute
                             (if (and (string? value)
                                      (cu/blank-value? value))
                               nil
                               value)
                             on-success!
                             on-error!))

(defn get-exports
  []
  (excel-export-actions/*->exports {}
                                   (fn [resp]
                                     (let [url (:download-url resp)]
                                       (when url
                                         (.open js/window url "_download"))))
                                   (fn [err]
                                     (logging/error "Failed to export to excel : " err))))

(defn get-logins
  []
  (excel-export-actions/*->logins {}
                                  (fn [resp]
                                    (let [url (:download-url resp)]
                                      (when url
                                        (.open js/window url "_download"))))
                                  (fn [err]
                                    (logging/error "Failed to export to excel : " err))))

(defn get-tokens
  []
  (tenant-actions/*->tokens {}
                            (fn [resp]
                              (let [tokens (:body resp)]
                                (swap! db/state assoc :tokens tokens)))
                            (fn [err]
                              (logging/error "Failed to get tokens : " err))))
